import { BaseComponent } from '../BaseComponent';
import { ComponentNames } from 'src/app/helper/componentNames';

export class DoNotSaveComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.doNotSaveComponent;
    }
}